import { Card, Stack, SxProps, Typography } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { DetailsAccordion, DetailsCard } from '../assignment-details-accordion/AssignmentDetailsAccordion';
import { ExerciseType } from '../types';
import { useDesktop } from '../useDesktop';
import { formatTime } from '../utils/formatTime';

export interface AssignmentDetailsProps {
  description: string;
  endTime?: Date;
  maxNumberOfAttempts?: number;
  showAssignmentVisibility?: boolean;
  startTime: Date;
  sx?: SxProps;
  type: ExerciseType;
  visibility: boolean;
}

const formatDateTime = (date: Date) => `${format(date, 'd MMM yyy')}, ${formatTime(date)}`;

const AssignmentDetails = ({
  description,
  endTime,
  maxNumberOfAttempts,
  showAssignmentVisibility,
  startTime,
  sx = {},
  type,
  visibility,
}: AssignmentDetailsProps) => {
  const isDesktop = useDesktop();
  const Wrapper = isDesktop ? DetailsCard : DetailsAccordion;

  return (
    <Card component="aside" sx={{ backgroundColor: theme => theme.palette.background.default, ...sx }}>
      <Wrapper header="Assignment details">
        <Stack>
          {description && (
            <>
              <Typography component="h2" variant="subtitle2">
                Subject
              </Typography>
              <Typography color="text.secondary" gutterBottom>
                {description}
              </Typography>
            </>
          )}
          <Typography component="h2" variant="subtitle2">
            From
          </Typography>
          <Typography color="text.secondary" gutterBottom>
            {formatDateTime(startTime)}
          </Typography>
          <Typography component="h2" variant="subtitle2">
            To
          </Typography>
          <Typography color="text.secondary" gutterBottom>
            {endTime ? formatDateTime(endTime) : '-'}
          </Typography>
          {type === ExerciseType.SelfStudy && (
            <>
              <Typography component="h2" variant="subtitle2">
                Maximum number of simulations
              </Typography>
              <Typography color="text.secondary" gutterBottom>
                {maxNumberOfAttempts || 'Unlimited'}
              </Typography>
            </>
          )}
          {showAssignmentVisibility && (
            <>
              <Typography component="h2" variant="subtitle2">
                Assessment visible for students
              </Typography>
              <Typography color="text.secondary">{visibility ? 'Yes' : 'No'}</Typography>
            </>
          )}
        </Stack>
      </Wrapper>
    </Card>
  );
};

export default AssignmentDetails;
